import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Como funciona o backup corporativo em Manaus?',
      answer: 'Nosso serviço de backup corporativo em Manaus oferece cópias automáticas dos seus dados com armazenamento local em nosso data center e replicação em nuvem. Utilizamos criptografia avançada para garantir a segurança das informações. O backup é realizado de forma incremental, otimizando o uso de banda e armazenamento. Em caso de necessidade, a recuperação dos dados é rápida e pode ser feita parcial ou totalmente, conforme sua necessidade.'
    },
    {
      question: 'Onde ficam localizados os servidores do data center?',
      answer: 'Nossos servidores estão localizados em data center próprio em Manaus, Amazonas. Toda a infraestrutura é própria, o que nos permite ter controle total sobre a qualidade, segurança e disponibilidade dos serviços. Isso também garante atendimento local rápido e suporte presencial quando necessário.'
    },
    {
      question: 'Por que os preços são fixos em reais?',
      answer: 'Trabalhamos com preços fixos em reais para oferecer transparência e previsibilidade financeira aos nossos clientes. Diferente de serviços internacionais que cobram em dólar, nossos valores não sofrem variação cambial, facilitando o planejamento orçamentário da sua empresa. Você sabe exatamente quanto vai pagar mensalmente pelos serviços de data center, backup corporativo e hospedagem de servidores em Manaus.'
    },
    {
      question: 'Como funciona o suporte técnico?',
      answer: 'Oferecemos suporte técnico 24/7 com atendimento humano real via WhatsApp no (92) 99142-6889 e telefone. Sem robôs, sem espera interminável. Nossa equipe especializada está sempre disponível para resolver problemas, tirar dúvidas e prestar assistência técnica. Para clientes em Manaus, também oferecemos atendimento presencial quando necessário.'
    },
    {
      question: 'Quais são as garantias de disponibilidade do data center?',
      answer: 'Nosso data center em Manaus conta com infraestrutura redundante de energia, climatização e conectividade para garantir máxima disponibilidade. Temos geradores de backup, nobreaks, múltiplos links de internet e monitoramento 24/7. Trabalhamos com SLA (Acordo de Nível de Serviço) que garante alta disponibilidade dos serviços de hospedagem de servidores virtuais e backup corporativo.'
    },
    {
      question: 'Como solicitar uma proposta personalizada?',
      answer: 'Para solicitar uma proposta personalizada de data center, backup corporativo ou hospedagem de servidores em Manaus, entre em contato conosco pelo WhatsApp (92) 99142-6889, telefone ou email contato@neotec.inf.br. Nossa equipe comercial fará um diagnóstico das suas necessidades e elaborará uma proposta com preço fixo em reais, detalhando todos os serviços e benefícios.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B3A6E] mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-gray-600">
            Tire suas dúvidas sobre data center, backup corporativo e hospedagem de servidores em Manaus.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h3 className="text-lg font-semibold text-[#0B3A6E] pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-down-s-line text-2xl text-[#F5A623] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'transform rotate-180' : ''}`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6 text-gray-600 leading-relaxed text-sm">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}